export function getPublicTrailerPlaybackId(video) {
  return video?.trailer_mux_playback_id || video?.mux_trailer_playback_id || video?.trailer_playback_id || null;
}

export function resolvePublicTrailer(video) {
  const playbackId = getPublicTrailerPlaybackId(video);
  return playbackId ? { playbackId, requiresAuthentication: false, requiresMembership: false } : null;
}

export function getTrailerStreamUrl(playbackId) {
  return playbackId ? `https://stream.mux.com/${playbackId}.m3u8` : "";
}

export function redactPlaybackId(playbackId) {
  return playbackId ? `${String(playbackId).slice(0, 4)}…` : "";
}

const scrub = (text, playbackId) => {
  let out = String(text || "").replace(/([?&](?:token|signature|expires)=)[^&\s"']*/gi, "$1<redacted>");
  if (playbackId) out = out.split(playbackId).join(redactPlaybackId(playbackId));
  return out;
};

// Handles a React <video> onError (nativeEvent.target.error) and <mux-player> error events.
export function describeMediaError(event, playbackId, { verbose = false } = {}) {
  const target = event?.nativeEvent?.target || event?.target || event?.currentTarget;
  const error = target?.error || event?.detail || {};
  const details = {
    code: error.code ?? null,
    source: scrub(getTrailerStreamUrl(playbackId), playbackId),
  };
  if (verbose) details.message = scrub(error.message, playbackId);
  return details;
}